module.exports = __webpack_public_path__ + "img/maze_rhombus_c.6613c3a1.svg";